import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { projectTitleInitialState } from '../reducers/project-title';
import config from './config';

class SB3Cloud extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'downloadProject'
        ]);
    }
    downloadProject(type = "") { 

        this.props.saveProjectSb3().then(content => {
            if (this.props.onSaveFinished) {
                this.props.onSaveFinished();
            }
            const formData = new FormData();
            formData.append('file', content);
            const filename = this.props.projectFilename;
            try {
                fetch(`${config.apiUrl}/upload?filename=${filename}&folder=${config.userId}&type=${type}`, {
                    method: 'POST',
                    body: formData,
                }).then(async response => {
                    if (!response.ok) {
                        const error = await response.json(); // Lê o conteúdo da resposta com erro
                        throw new Error(error || 'Erro desconhecido');
                    }
                    alert("Projeto salvo com sucesso!");
                }).catch(error => {
                    alert(error.message);
                });


            } catch (error) {
                console.error('Error:', error);
            }
        })
        //downloadBlob(this.props.projectFilename, content);

    }
    render() {
        const {
            children
        } = this.props;
        return children(
            this.props.className,
            this.downloadProject
        );
    }
}

const getProjectFilename = (curTitle, defaultTitle) => {
    let filenameTitle = curTitle;
    if (!filenameTitle || filenameTitle.length === 0) {
        filenameTitle = defaultTitle;
    }
    return `${filenameTitle.substring(0, 100)}.ob`;
};

SB3Cloud.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    onSaveFinished: PropTypes.func,
    projectFilename: PropTypes.string,
    saveProjectSb3: PropTypes.func
};
SB3Cloud.defaultProps = {
    className: ''
};

const mapStateToProps = state => ({
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    projectFilename: getProjectFilename(state.scratchGui.projectTitle, projectTitleInitialState)
});

export default connect(
    mapStateToProps,
    () => ({}) // omit dispatch prop
)(SB3Cloud);
